module.exports = __webpack_public_path__ + "img/개인위생.0e395ce8.png";